<template>
  <div class="zzl-container">
    <div class="zzl-content">
      <div class="zzl-title">用户点餐记录</div>
      <div class="flex-between">
        <div class="zzl-search-list">
          <div class="zzl-search-item">
            <p>点餐时间</p>
            <el-date-picker
              v-model="search.startEndDates"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              clearable
              @change="searchData"
            >
            </el-date-picker>
          </div>
          <div class="zzl-search-item">
            <p>点餐类型</p>
            <el-select
              v-model="search.meal_type"
              placeholder="请选择"
              clearable
              @change="searchData"
            >
              <el-option
                v-for="item in [{ value: '', label: '全部' }].concat(mealTypeList)"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="zzl-search-item">
            <p>支付类型</p>
            <el-select
              v-model="search.pay_type"
              placeholder="请选择"
              clearable
              @change="searchData"
            >
              <el-option
                v-for="item in [{ value: '', label: '全部' }].concat(payTypeList)"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="zzl-search-item">
            <el-button type="primary" @click="searchData">查询</el-button>
          </div>
        </div>
        <div class="zzl-search-list">
          <div class="zzl-search-item">
            <p></p>
            <el-select v-model="exportData.pageNum" placeholder="请选择">
              <el-option
                v-for="item in exportList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="zzl-search-item">
            <el-button type="primary" @click="exportExcel">导出</el-button>
          </div>
        </div>
      </div>
      <div class="zzl-table-list">
        <el-table
          ref="tableRef"
          :data="tableList"
          max-height="640px"
          style="width: 100%"
        >
          <el-table-column
            prop="member_name"
            label="点餐人员"
            min-width="100"
            align="center"
            fixed="left"
          >
          </el-table-column>
          <el-table-column
            prop="meal_name"
            label="点餐"
            min-width="240"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="goods_amount"
            label="点餐数量"
            min-width="100"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="meal_date"
            label="点餐时间"
            min-width="200"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="type"
            label="点餐类型"
            min-width="100"
            align="center"
          >
            <template slot-scope="scope">
              <div>
                {{ scope.row.type == "supper" ? "晚餐" : "午餐" }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="meal_price"
            label="单价/元"
            min-width="100"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="pay_type"
            label="支付类型"
            min-width="120"
            align="center"
          >
            <template slot-scope="scope">
              <div>
                {{ scope.row.pay_type == "C" ? "公司免费工作餐" : "员工自费" }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="pay_amount"
            label="应付费用/元"
            min-width="100"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="receive_amount"
            label="实际支付/元"
            min-width="100"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="member_floor"
            label="所在楼层"
            min-width="100"
            align="center"
          >
          </el-table-column>
        </el-table>
        <div class="flex-end-center">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-sizes="[10, 20, 30, 40]"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="pagination.pageNum"
            :page-size="pagination.pageSize"
            :total="pagination.count"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "orderRecord",
  data() {
    return {
      tableList: [],
      pagination: {
        pageNum: 1,
        pageSize: 20,
        count: 0,
      },
      search: {
        startEndDates: [],
        pay_type: "",
        meal_type: ""
      },
      mealTypeList: [
        {
          value: "lunch",
          label: "午餐",
        },
        {
          value: "supper",
          label: "晚餐",
        },
      ],
      payTypeList: [
        {
          value: "C",
          label: "公司免费工作餐",
        },
        {
          value: "M",
          label: "员工自费",
        },
      ],
      exportData: {
        pageNum: 1,
        pageSize: 1000,
      },
      exportList: [],
    };
  },
  methods: {
    // 导出
    exportExcel() {
      if (this.pagination.count == 0) {
        this.$message.error("当前没有数据");
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: "正在导出中, 请等待...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.getList((res) => {
        res.forEach((item) => {
          item.type = item.type == "supper" ? "晚餐" : "午餐";
          item.pay_type = item.pay_type == "C" ? "公司免费工作餐" : "员工自费";
        });
        let tHeader = [];
        let filterVal = [];
        let columns = this.$refs.tableRef.columns;
        columns.forEach((item) => {
          tHeader.push(item.label);
          filterVal.push(item.property);
        });
        this.zzlFormat.exportExcel(
          tHeader,
          filterVal,
          res,
          "点餐信息表",
          loading
        );
      });
    },
    getExportList(count, size = 1000) {
      if (!count) {
        return
      }
      let list = [];
      let num = Math.floor(count / size);
      for (let i = 0; i < num; i++) {
        let item = {
          label: size * i + 1 + "~" + size * (i + 1) + "条",
          value: i + 1,
        };
        list.push(item);
      }
      let lastItem = {
        label: size * num + 1 + "~" + count + "条",
        value: num + 1,
      };
      list.push(lastItem);
      return list;
    },
    handleCurrentChange(val) {
      this.pagination.pageNum = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.pagination.pageNum = 1;
      this.pagination.pageSize = val;
      this.getList();
    },
    searchData() {
      this.pagination.pageNum = 1;
      this.getList();
    },
    // 获取列表
    async getList(success) {
      let params = {
        ...this.pagination,
        ...this.search,
      };
      if (success) {
        params = {
          ...params,
          ...this.exportData,
        };
      }
      const res = await this.zzlHttp.post(
        this.zzlApi.getMemOrderRecordList,
        params
      );
      if (res.code === 0 && res.data) {
        console.log(111,res.data)
        if (success) {
          success(res.data.list);
        } else {
          this.pagination.count = res.data.count || 0;
          this.tableList = res.data.list || [];
          this.exportList = this.getExportList(res.data.count);
        }
      }
    },
  },
  mounted() {
    this.getList();
  },
};
</script>

<style lang="scss" scoped>
</style>
